
export default function HowItWorks() {
  const steps = [
    {
      number: "01",
      title: "Lead Verification",
      description: "We receive new leads daily and personally call each one to verify they're legitimate individuals or couples seeking a new provider, assess medical needs, and confirm budget for medical membership.",
      icon: "ri-phone-line"
    },
    {
      number: "02",
      title: "Facebook Page Posting",
      description: "Verified leads are posted anonymously on our free Facebook page with relevant details about location and patient needs.",
      icon: "ri-facebook-fill"
    },
    {
      number: "03",
      title: "Practice Interest",
      description: "Practices follow our Facebook page, see new leads as they're added, and comment if interested in an introduction. We encourage tagging friends with practices in the patient's area.",
      icon: "ri-chat-3-line"
    },
    {
      number: "04",
      title: "Contact Information Sharing",
      description: "Our team provides the patient's contact information to interested practices for direct outreach and consultation scheduling.",
      icon: "ri-contacts-line"
    },
    {
      number: "05",
      title: "Performance-Based Payment",
      description: "If the patient signs up with your practice, you pay $200 per individual or $350 per couple. If they don't sign up, no payment is due.",
      icon: "ri-money-dollar-circle-line"
    }
  ];

  const stepImages = [
    "https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/f27e4996ef4af682eb80ea5918cb8ca9.png",
    "https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/9e010d2afb8762e302a0ebefdf1b86d5.png",
    "https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/9b02fd2f1bbe1bdbf61dcbc659085eff.png",
    "https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/ad1ea52def82f44f62b0730fdd7774a8.png",
    "https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/fe5ba0dd0f990582f1cafc7edbf6df00.png"
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How Our Lead Generation Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our proven 5-step process ensures you get verified, high-quality patient leads through our Facebook community with no upfront costs.
          </p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center gap-8 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className="lg:w-1/2">
                <div className="bg-gray-50 p-8 rounded-2xl">
                  <img 
                    src={stepImages[index]}
                    alt={step.title}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
              </div>
              <div className="lg:w-1/2">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-xl font-bold mr-4">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className={`${step.icon} text-2xl text-blue-600`}></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-lg text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
